// extracted by mini-css-extract-plugin
module.exports = {"rightCorner":"CmptNoDataAvailable_rightCorner__1nIIQ","leftCorner":"CmptNoDataAvailable_leftCorner__3LbjZ"};